import React from 'react';
import { Button, CircularProgress } from '@mui/material';

class NavigationHandler {
  constructor(formComponent) {
    this.form = formComponent;
  }

  handleToPage = (index) => {
    this.form.props.dispatchgoBackToANY(index);
  };

  handleNext = async (event, pageIndex) => {
    this.form.setState({
      sended: true,
    });

    if (this.form.isAuthenticated() === false) {
      this.form.setState({ authState: 'signIn', sended: false });
    } else {
      if (this.form.checkAllAnswered() == true) {
        let { form } = this.form.props;
        let password = this.form.state.password || '';
        let form_id = this.form.state.form_id;

        if (pageIndex === undefined) {
          pageIndex = (parseInt(form.current_index) + 1).toString();
        }

        // Guard: Don't go past the last page
        if (parseInt(pageIndex) >= form.form_length) {
          this.form.setState({ sended: false });
          return;
        }
        this.form.props.dispatchFormLoading();
        const promise = new Promise(this.form.dataManager.handlePageLoad).then(
          await this.form.props.dispatchfetchNextPage(
            password,
            form_id,
            pageIndex,
            this.form.state.projectVersion,
            this.form.state.projectSessionId,
            this.form.state.threadId
          ),
          this.form.setState({
            current_index: pageIndex,
            isReady: true,
            password_alert: false,
            loading: false,
            sended: false,
          }),
          (document.documentElement.scrollTop = 0)
        );

        this.form.visitedPages.add(parseInt(pageIndex));
      } else {
        document.documentElement.scrollTop = 0;
        this.form.setState({
          sended: false,
        });
      }
    }
  };

  handleBack = async () => {
    this.form.setState({
      sended: true,
    });
    this.form.props.dispatchFormLoading();
    await this.form.props.dispatchgoBackToPrevious();
    document.documentElement.scrollTop = 0;

    this.form.setState({
      sended: false,
    });

  };

  handleToHome = () => {
    // Use React Router's history instead of direct window manipulation
    this.form.props.history.push('/');
  };

  handleRedo = () => {
    if (this.form.isAuthenticated() === false) {
      this.form.setState({ authState: 'signIn' });
    } else {
      this.form.setState({
        sended: false,
        response: false,
        finished: false,
        processD: false,
      });
    }
  };

  renderBreadCrums = () => {
    const view = [];
    const data = this.form.props.form.request_data;
    const current_index = this.form.props.form.current_index;

    if (this.form.props.form.current_index <= 3) {
      for (let i = 0; i <= this.form.props.form.current_index; i++) {
        view.push(
          <div className="renderBreadCrumsDiv" key={i}>
            <p
              onClick={() => this.handleToPage(i)}
              className="renderBreadCrumsPtag"
            >
              {data[i].title.view.data.default}
            </p>
            {data[i].title.view.data.default != undefined &&
            data[i].title.view.data.default.length != 0 &&
            i != this.form.props.form.current_index ? (
              <div>&nbsp; | &nbsp;</div>
            ) : (
              ''
            )}
          </div>
        );
      }
    } else {
      view.push(
        <div className="renderBreadCrumsDivElse" key="breadcrumb-start">
          &nbsp;
          <p
            onClick={() => this.handleToPage(0)}
            className="renderBreadCrumsPtag"
          >
            {data[0].title.view.data.default}
          </p>
          &nbsp; /
        </div>
      );
      view.push(
        <div className="renderBreadCrumsDivElse" key="breadcrumb-1">
          &nbsp;
          <p
            onClick={() => this.handleToPage(1)}
            className="renderBreadCrumsPtag"
          >
            {data[1].title.view.data.default}
          </p>
          &nbsp; /
        </div>
      );
      view.push(
        <div className="renderBreadCrumsDivElse" key="breadcrumb-ellipsis">
          &nbsp;
          <p
            style={{
              maxWidth: 60,
              margin: 0,
              overflowX: 'hidden',
              whiteSpace: 'nowrap',
            }}
          >
            ...
          </p>
          &nbsp; /
        </div>
      );
      view.push(
        <div className="renderBreadCrumsDivElse" key="breadcrumb-prev">
          &nbsp;
          <p
            onClick={() =>
              this.handleToPage(this.form.props.form.current_index - 1)
            }
            className="renderBreadCrumsPtag"
          >
            {
              data[this.form.props.form.current_index - 1].title.view.data
                .default
            }
          </p>
          &nbsp; /
        </div>
      );
      view.push(
        <div className="renderBreadCrumsDivElse" key="breadcrumb-current">
          &nbsp;
          <p
            onClick={() =>
              this.handleToPage(this.form.props.form.current_index)
            }
            className="renderBreadCrumsPtag"
          >
            {data[this.form.props.form.current_index].title.view.data.default}
          </p>
          &nbsp; /
        </div>
      );
    }

    return view;
  };
}

export default NavigationHandler;
